import { render } from "./ComputeOfferingSelection.vue?vue&type=template&id=5fc00d79&scoped=true"
import script from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"
export * from "./ComputeOfferingSelection.vue?vue&type=script&lang=js"

import "./ComputeOfferingSelection.vue?vue&type=style&index=0&id=5fc00d79&lang=less&scoped=true"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc00d79"]])

export default __exports__